import { render, staticRenderFns } from "./market.vue?vue&type=template&id=af4270b4&scoped=true&"
import script from "./market.vue?vue&type=script&lang=js&"
export * from "./market.vue?vue&type=script&lang=js&"
import style0 from "./market.vue?vue&type=style&index=0&id=af4270b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4270b4",
  null
  
)

export default component.exports